var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',[_c('d2-page-cover',{attrs:{"title":"试验台","sub-title":"在这里可以测试一些 D2Admin 的系统功能"}},[_c('img',{attrs:{"src":require("./image/icon.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }